<template>
  <overview
    :locationService = locationService
    :locationComponent = locationComponent
  ></overview>
</template>

<script>
  import Overview from '@/components/Common/Rental/Locations/Overview'
  import locationService from '@/services/licensor/location'

  export default {
    components: {
      Overview,
    },

    data () {
      return {
        locationService: locationService,
        locationComponent: 'LicensorLocation',
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Licensor/Locations/Overview.vue